import {Component, Directive, EventEmitter, Input, NgModule, Output} from '@angular/core';

export class SdChipInputEvent {
  constructor(
    public input: HTMLInputElement,
    public value: string,
    public chipInput: {clear: () => void},
  ) {}
}

export class SdChipEditedEvent {
  constructor(public chip: unknown, public value: string) {}
}

@Component({
  selector: 'sd-chip, sd-chip-row, sd-chip-option',
  standalone: true,
  template: `
    <span class="inline-flex items-center gap-1 rounded-full bg-[var(--m365-bg-subtle,#f4f4f7)] px-2.5 py-1 text-xs">
      <ng-content></ng-content>
      <button type="button" class="ml-1 text-[var(--m365-text-secondary,#6b6b70)]" (click)="removed.emit()">×</button>
    </span>
  `,
  host: {class: 'sd-chip inline-flex'},
})
export class SdChip {
  @Input() color: string | undefined;
  @Input() selected = false;
  @Input() removable = true;
  @Output() removed = new EventEmitter<void>();
}

@Component({
  selector: 'sd-chip-set, sd-chip-grid, sd-chip-listbox',
  exportAs: 'sdChipGrid, sdChipSet',
  standalone: true,
  template: `<div class="flex flex-wrap gap-1"><ng-content></ng-content></div>`,
  host: {class: 'sd-chip-set block'},
})
export class SdChipGrid {}

@Directive({
  selector: '[sdChipRemove]',
  standalone: true,
  host: {'(click)': 'onClick()'},
})
export class SdChipRemove {
  constructor(private readonly chip: SdChip) {}
  onClick(): void {
    this.chip.removed.emit();
  }
}

@Directive({
  selector: '[sdChipInputFor]',
  standalone: true,
})
export class SdChipInput {
  @Input() sdChipInputFor: SdChipGrid | null = null;
  @Input() sdChipInputSeparatorKeyCodes: readonly number[] = [13];
  @Input() sdChipInputAddOnBlur = false;
  @Output() sdChipInputTokenEnd = new EventEmitter<SdChipInputEvent>();

  constructor() {}

  emitToken(input: HTMLInputElement): void {
    const value = (input.value || '').trim();
    this.sdChipInputTokenEnd.emit(
      new SdChipInputEvent(input, value, {
        clear: () => {
          input.value = '';
        },
      }),
    );
  }

  onKeydown = (event: KeyboardEvent) => {
    if (this.sdChipInputSeparatorKeyCodes.includes(event.keyCode) || event.key === 'Enter') {
      event.preventDefault();
      this.emitToken(event.target as HTMLInputElement);
    }
  };

  onBlur = (event: FocusEvent) => {
    if (this.sdChipInputAddOnBlur) {
      this.emitToken(event.target as HTMLInputElement);
    }
  };
}

@Directive({
  selector: 'input[sdChipInputFor]',
  standalone: true,
  host: {
    '(keydown)': 'onKeydown($event)',
    '(blur)': 'onBlur($event)',
  },
})
export class SdChipInputHost extends SdChipInput {}

@NgModule({
  imports: [SdChip, SdChipGrid, SdChipRemove, SdChipInputHost],
  exports: [SdChip, SdChipGrid, SdChipRemove, SdChipInputHost],
})
export class SdChipsModule {}
